import React from 'react'
import { connect } from 'react-redux'
import { Col, Container, Row, Table } from 'reactstrap'
import { MarketData } from "react-ts-tradingview-widgets";
import { translate } from "views/utils/translate";

const MarketDataSymbolsGroup = [
    {
        "name": "ETFs",
        "originalName": "ETFs",
        "symbols": [
            {
                "name": "NASDAQ:TQQQ",
                "displayName": "ProShares UltraPro QQQ"
            },
            {
                "name": "NASDAQ:QQQ",
                "displayName": "Invesco QQQ Trust"
            },
            {
                "name": "AMEX:XLV",
                "displayName": "SPDR Select Sector Fund - Health Care"
            },
            {
                "name": "AMEX:GLD",
                "displayName": "SPDR Gold Shares"
            },
            {
                "name": "AMEX:VNQ",
                "displayName": "Vanguard Real Estate ETF"
            },
            {
                "name": "AMEX:IWM",
                "displayName": "iShares Russell 2000 ETF"
            }
        ]
    }
]

function ETFContent(props) {

    return (
        <>
            <div className='forexContent px-4 px-lg-0'>
                <Container className='w-100 h-100'>
                    <Row className='justify-content-center align-items-stretch px-0 mx-0 w-100 h-100'>
                        <Col lg={12} md={12} sm={12} xs={12} className='mb-3 mt-4'>
                            <span className='font-Bold sectionDivTitle text-white d-block text-left mb-3'>
                            {translate(props.lang, "Live Chart")}
                            </span>
                            <div className='contentLiveChartBox'>
                                <MarketData colorTheme="dark" locale={props.lang === "ZH" ? "zh_CN": "en"} isTransparent={true} symbolsGroups={MarketDataSymbolsGroup} width="100%" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { i18n } = state;
    return {
        lang: i18n.lang
    }
}

export default connect(mapStateToProps)(ETFContent);